import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonToastService } from '@common2/services/toast.service';
import { TranslateService } from '@services';
import { SubscriptionLearnerService, LmsSubscription } from 'src/app/services/subscription-learner.service';

@Component({
    selector: 'msc-account-subscription',
    templateUrl: './subscription.component.html',
    styleUrls: ['./subscription.component.scss'],
})
export class AccountSubscriptionComponent implements OnInit {
    @ViewChild('cancelModal') cancelModal: any;

    public subscription: LmsSubscription | null = null;
    public isLoading = true;
    public isCancelling = false;
    public cancelReason = '';

    constructor(
        private subscriptionService: SubscriptionLearnerService,
        private toastService: CommonToastService,
        private translateService: TranslateService,
    ) {}

    ngOnInit(): void {
        this.load();
    }

    load(): void {
        this.isLoading = true;
        this.subscriptionService.getMySubscription().subscribe({
            next: (sub) => {
                this.subscription = sub;
                this.isLoading = false;
            },
            error: () => {
                this.isLoading = false;
            },
        });
    }

    get isLifetime(): boolean {
        return this.subscription?.plan?.isLifetime === true;
    }

    get isPendingCancellation(): boolean {
        return this.subscription?.cancelAtPeriodEnd === true;
    }

    get showCancelButton(): boolean {
        const status = this.subscription?.status;
        return (status === 'active' || status === 'trial')
            && !this.isLifetime
            && !this.isPendingCancellation;
    }

    openCancelModal(): void {
        this.cancelReason = '';
        this.cancelModal?.onOpen();
    }

    confirmCancel(): void {
        if (!this.subscription || this.isCancelling) {
            return;
        }
        this.isCancelling = true;
        this.subscriptionService.cancelSubscription(
            this.subscription.id,
            this.cancelReason || undefined
        ).subscribe({
            next: () => {
                this.isCancelling = false;
                this.cancelModal?.onClose();
                this.toastService.onSuccess(
                    this.translateService.instant('lms-subscription.cancellation-scheduled')
                );
                this.load();
            },
            error: () => {
                this.isCancelling = false;
                this.toastService.onError(
                    this.translateService.instant('toast.error-occurred')
                );
            },
        });
    }
}
